<template>
  <div class="uk-container uk-margin-medium-top">
    <router-link to="create-project"><p>Create Project</p></router-link>
    <router-link to="org-patterns"><p>Manage Org Patterns</p></router-link>
    <router-link to="/admin/colors"><p>Manage Colors</p></router-link>
    <input class="uk-input uk-width-1-6" v-model="enteredProject" />
    <router-link :to="'/admin/project/' + enteredProject"
      ><button class="uk-button uk-button-primary">
        Go to Project
      </button></router-link
    >
  </div>
</template>

<script>
import UIkit from "uikit";

export default {
  name: "AdminUpload",
  data() {
    return {
      enteredProject: ""
    };
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/AdminPortal.vue